import { adminLoginApi } from "../../api/admin/adminLoginApi"

export async function adminAuthService(payload: { username: string; password: string }) {
	const { token } = await adminLoginApi(payload)
	return { token }
}
